export default "__VITE_ASSET__BbpupnSF__"